// extracted by mini-css-extract-plugin
module.exports = {"center":"numeric-input_center__1YrNT"};